import { BaseFilterCondition, LogicalCondition } from '@adaptiva/core/filters';
import { EJavaClassNames } from '@adaptiva/data-service';
import { DeletedObjectsFilterService, MetadataSerialization, RelationshipsProperties } from '@adaptiva/metadata/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BaseAuthoringPropertiesComponent } from '../base-authoring-component';

@Component({
	standalone: false,
	selector: 'ada-relationships-properties',
	templateUrl: 'relationships-properties.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class RelationshipsPropertiesComponent extends BaseAuthoringPropertiesComponent<RelationshipsProperties> {

	public override propertyConstructor: MetadataSerialization.Deserializable<RelationshipsProperties> = RelationshipsProperties;

	protected readonly deletedObjectsFilterService: DeletedObjectsFilterService = inject(DeletedObjectsFilterService);

	protected readonly deletedObjectsFilter: LogicalCondition = this.deletedObjectsFilterService.getHideDeletedFilter();

	protected readonly relationshipsClassName: EJavaClassNames = EJavaClassNames.MetadataObject;

	public setPrerequisiteInstallTree(_tree: BaseFilterCondition): void {
		if (_tree) {
			if (this.currentPropertyObject.PrerequisiteInstalls)
				this.setObjectPropertyValue('PrerequisiteInstalls', []);

			this.setObjectPropertyValue('PrerequisiteInstallTree', _tree);
		}
	}

	public setFollowupInstallTree(_tree: BaseFilterCondition): void {
		if (_tree) {
			if (this.currentPropertyObject.FollowupInstalls)
				this.setObjectPropertyValue('FollowupInstalls', []);

			this.setObjectPropertyValue('FollowupInstallTree', _tree);
		}
	}

}
